// router/index.js
import {
	createRouter,
	createWebHashHistory,
	createWebHistory
} from 'vue-router'
import { Capacitor } from '@capacitor/core'
import { ChatPlugin } from '@/plugins/chat'
import { useUserStore } from '@/stores/user'
import { isSocialEnabled } from '@/api/appVersion'

const routes = [
	{
		path: '/splash',
		component: () => import('@/views/Splash.vue'),
		meta: {
			title: '启动页',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/',
		component: () => import('@/views/Top.vue'),
		meta: {
			title: '推荐',
			requiresAuth: false,
			showTabBar: true
		}
	},
	{
		path: '/service',
		component: () => import('@/views/Service.vue'),
		meta: {
			title: '服务套餐',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/service/city-vote',
		component: () => import('@/views/service/CityVote.vue'),
		meta: {
			title: '城市投票',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/tech',
		component: () => import('@/views/Tech.vue'),
		meta: {
			title: '健康师列表',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/chat',
		component: () => import('@/views/chat/List.vue'),
		meta: {
			title: '聊天会话',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/chat-message',
		component: () => import('@/views/chat/Message.vue'),
		meta: {
			title: '聊天消息',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'TechDetail',
		path: '/tech-detail',
		component: () => import('@/views/tech/TechDetail.vue'),
		meta: {
			title: '健康师详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'MerchantDetail',
		path: '/merchant-detail',
		component: () => import('@/views/merchant/MerchantDetail.vue'),
		meta: {
			title: '商家详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'TechPortfolio',
		path: '/tech-portfolio',
		component: () => import('@/views/tech/TechPortfolio.vue'),
		meta: {
			title: '个人作品主页',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'TechReview',
		path: '/tech-review',
		component: () => import('@/views/tech/Review.vue'),
		meta: {
			title: '评价健康师',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'TechReviews',
		path: '/tech-reviews',
		component: () => import('@/views/tech/Reviews.vue'),
		meta: {
			title: '健康师评价',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/video',
		component: () => import('@/views/Video.vue'),
		meta: {
			title: '视频',
			requiresAuth: false,
			showTabBar: true
		}
	},
	{
		path: '/message-center',
		component: () => import('@/views/message/Center.vue'),
		meta: {
			title: '消息中心',
			requiresAuth: true,
			showTabBar: true
		}
	},
	{
		path: '/message-list',
		component: () => import('@/views/message/List.vue'),
		meta: {
			title: '消息列表',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/top',
		component: () => import('@/views/Top.vue'),
		meta: {
			title: '推荐',
			requiresAuth: false,
			showTabBar: true
		}
	},
	{
		path: '/portfolio/detail',
		component: () => import('@/views/portfolio/PortfolioDetail.vue'),
		meta: {
			title: '动态详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/portfolio/topic',
		component: () => import('@/views/portfolio/HotTopicList.vue'),
		meta: {
			title: '热门话题',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/my',
		component: () => import('@/views/My.vue'),
		meta: {
			title: '我的',
			requiresAuth: true,
			showTabBar: true
		}
	},
	{
		path: '/health',
		component: () => import('@/views/Health.vue'),
		meta: {
			title: '春信',
			requiresAuth: false,
			showTabBar: true
		}
	},
	{
		name: 'MoxaNeck',
		path: '/health/moxa-neck',
		component: () => import('@/views/health/MoxaNeck.vue'),
		meta: {
			title: '肩颈调理艾灸',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'MoxaSpleen',
		path: '/health/moxa-spleen',
		component: () => import('@/views/health/MoxaSpleen.vue'),
		meta: {
			title: '脾胃调理艾灸',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'MoxaQi',
		path: '/health/moxa-qi',
		component: () => import('@/views/health/MoxaQi.vue'),
		meta: {
			title: '气血调理艾灸',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/package-detail',
		component: () => import('@/views/service/PackageDetail.vue'),
		meta: {
			title: '套餐详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/my/setting',
		component: () => import('@/views/my/Setting.vue'),
		meta: {
			title: '设置',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/recharge',
		component: () => import('@/views/my/Recharge.vue'),
		meta: {
			title: '充值',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/recharge-history',
		component: () => import('@/views/my/RechargeHistory.vue'),
		meta: {
			title: '充值记录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/tip-history',
		component: () => import('@/views/my/TipHistory.vue'),
		meta: {
			title: '打赏记录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/personal',
		component: () => import('@/views/my/Personal.vue'),
		meta: {
			title: '个人信息',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/edit-mobile',
		component: () => import('@/views/my/EditMobile.vue'),
		meta: {
			title: '修改手机号',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'OrderList',
		path: '/order/list',
		component: () => import('@/views/order/OrderList.vue'),
		meta: {
			title: '订单',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/order/detail',
		component: () => import('@/views/order/OrderDetail.vue'),
		meta: {
			title: '订单详情',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'OrderBooking',
		path: '/order/order-booking',
		component: () => import('@/views/order/OrderBooking.vue'),
		meta: {
			title: '预约下单',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'OrderExtend',
		path: '/order/order-extend',
		component: () => import('@/views/order/OrderExtend.vue'),
		meta: {
			title: '订单加钟',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'AddressList',
		path: '/address/list',
		component: () => import('@/views/address/AddressList.vue'),
		meta: {
			title: '地址列表',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'AddressSave',
		path: '/address/save',
		component: () => import('@/views/address/AddressSave.vue'),
		meta: {
			title: '地址保存',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'Story',
		path: '/core/story',
		component: () => import('@/views/core/Story.vue'),
		meta: {
			title: '我们的故事',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'Academy',
		path: '/core/academy',
		component: () => import('@/views/core/Academy.vue'),
		meta: {
			title: '香学院',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'Formula',
		path: '/core/formula',
		component: () => import('@/views/core/Formula.vue'),
		meta: {
			title: '配方',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'Product',
		path: '/core/product',
		component: () => import('@/views/core/Product.vue'),
		meta: {
			title: '产品',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/login',
		component: () => import('@/views/Login.vue'),
		meta: {
			title: '登录',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/mobile-login',
		component: () => import('@/views/MobileLogin.vue'),
		meta: {
			title: '手机号登录',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/login-callback',
		component: () => import('@/views/callback/LoginCallback.vue'),
		meta: {
			title: '登录中',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/account-error',
		component: () => import('@/views/AccountError.vue'),
		meta: {
			title: '帐号异常',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/select-location',
		name: 'SelectLocation',
		component: () => import('@/views/location/SelectLocation.vue'),
		meta: {
			title: '选择位置',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/city-selection',
		name: 'CitySelection',
		component: () => import('@/views/location/CitySelection.vue'),
		meta: {
			title: '选择城市',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/map-distance',
		name: 'MapDistance',
		component: () => import('@/views/location/Distance.vue'),
		meta: {
			title: '地图',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/my/preference',
		component: () => import('@/views/my/Preference.vue'),
		meta: {
			title: '偏好设置',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/favorites',
		component: () => import('@/views/my/Favorites.vue'),
		meta: {
			title: '关注列表',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/coupon-list',
		component: () => import('@/views/my/CouponList.vue'),
		meta: {
			title: '我的优惠券',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/city-list',
		component: () => import('@/views/CityList.vue'),
		meta: {
			title: '已开通城市',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/my/feedback',
		component: () => import('@/views/my/Feedback.vue'),
		meta: {
			title: '用户反馈',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/feedback-history',
		component: () => import('@/views/my/FeedbackHistory.vue'),
		meta: {
			title: '反馈记录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/feedback-detail',
		component: () => import('@/views/my/FeedbackDetail.vue'),
		meta: {
			title: '反馈详情',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/after-sale/apply',
		name: 'AfterSaleApply',
		component: () => import('@/views/after-sale/Apply.vue'),
		meta: {
			title: '申请售后',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/after-sale/detail',
		name: 'AfterSaleDetail',
		component: () => import('@/views/after-sale/Detail.vue'),
		meta: {
			title: '售后详情',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/after-sale',
		name: 'AfterSaleList',
		component: () => import('@/views/my/AfterSale.vue'),
		meta: {
			title: '售后记录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/official-account',
		component: () => import('@/views/my/OfficialAccount.vue'),
		meta: {
			title: '扫码关注',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/my/invite-code',
		name: 'MyInviteCode',
		component: () => import('@/views/my/MyInviteCode.vue'),
		meta: {
			title: '我的邀请码',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/invite-detail',
		name: 'InviteDetail',
		component: () => import('@/views/my/InviteDetail.vue'),
		meta: {
			title: '邀请明细',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/invite-share',
		name: 'InviteShare',
		component: () => import('@/views/InviteShare.vue'),
		meta: {
			title: '邀请好友',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/invite',
		name: 'InviteRegister',
		component: () => import('@/views/InviteRegister.vue'),
		meta: {
			title: '好友邀请',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/invite-technician',
		name: 'MerchantInviteRegister',
		component: () => import('@/views/MerchantInviteRegister.vue'),
		meta: {
			title: '商家邀请',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/vip/purchase',
		component: () => import('@/views/VipPurchase.vue'),
		meta: {
			title: '会员中心',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/corp/index',
		component: () => import('@/views/corp/Index.vue'),
		meta: {
			title: '关于',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/policy',
		component: () => import('@/views/corp/Policy.vue'),
		meta: {
			title: '隐私政策',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/agreement',
		component: () => import('@/views/corp/Agreement.vue'),
		meta: {
			title: '用户协议',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/duty',
		component: () => import('@/views/corp/Duty.vue'),
		meta: {
			title: '责任声明',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/booking-notice',
		component: () => import('@/views/corp/BookingNotice.vue'),
		meta: {
			title: '预约须知',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/privacy-protection',
		component: () => import('@/views/corp/PrivacyProtection.vue'),
		meta: {
			title: '号码保护说明',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/about-us',
		component: () => import('@/views/corp/AboutUs.vue'),
		meta: {
			title: '关于我们',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/rtc/test',
		component: () => import('@/views/rtc/Test.vue'),
		meta: {
			title: 'RTC 语音测试',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/freelancer/apply',
		component: () => import('@/views/freelancer/Apply.vue'),
		meta: {
			title: '健康师合作意向登记',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/freelancer/recruit',
		component: () => import('@/views/freelancer/Recruit.vue'),
		meta: {
			title: '招聘合作',
			requiresAuth: false,
			showTabBar: false
		}
	},
]

const router = createRouter({
	//history: createWebHistory(), // 微信H5建议用hash模式，也不一定。
	history: createWebHashHistory(), // 改为Hash模式，URL会带#
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 如果有保存的位置（比如浏览器后退），返回该位置
		if (savedPosition) {
			return savedPosition
		}

		// 默认滚动到顶部
		return { top: 0 }
	}
})

// 全局变量：记录登录后要跳转的目标页
let loginTargetPath = '';
// 标记是否已检查过启动页（避免重复检查）
let splashChecked = false;

/**
 * 判断是否需要显示启动页
 */
const shouldShowSplash = () => {
	console.log('🎨 [路由-启动页检查] 开始检查')

	// 如果已经检查过，不再重复检查
	if (splashChecked) {
		console.log('🎨 [路由-启动页检查] 已检查过，跳过')
		return false
	}

	// 测试模式：URL 带有 forceSplash=true 强制显示
	if (window.location.search.includes('forceSplash=true')) {
		console.log('🎨 [路由-启动页检查] 测试模式：强制显示')
		splashChecked = true
		return true
	}

	// 检查 URL 参数，如果带有 noSplash=true 则不显示
	if (window.location.search.includes('noSplash=true')) {
		console.log('🎨 [路由-启动页检查] URL 参数禁止显示')
		splashChecked = true
		return false
	}

	// 检查是否已经显示过启动页（本次会话）
	const sessionShown = sessionStorage.getItem('splash_shown')
	if (sessionShown) {
		console.log('🎨 [路由-启动页检查] 本次会话已显示过')
		splashChecked = true
		return false
	}

	// 检查今日是否已显示过
	const lastShown = localStorage.getItem('splash_last_shown')
	const today = new Date().toDateString()

	if (lastShown !== today) {
		localStorage.setItem('splash_last_shown', today)
		sessionStorage.setItem('splash_shown', 'true')
		console.log('🎨 [路由-启动页检查] 每日首次启动，显示启动页')
		splashChecked = true
		return true
	}

	console.log('🎨 [路由-启动页检查] 今日已显示过，跳过')
	splashChecked = true
	return false
}

// 动态设置标题
router.beforeEach(async (to, from, next) => {
	console.log('🧭 路由导航:', from.path, '->', to.path)
	console.log('🧭 目标组件:', to.matched.map(r => r.components?.default?.__name || r.path))
	document.title = to.meta.title + '-春信精油' || '春信精油'

	// 启动页检查：访问首页时检查是否需要显示启动页
	if (to.path === '/' && from.path === '/' && shouldShowSplash()) {
		console.log('🎨 [路由-启动页检查] 重定向到启动页')
		next('/splash')
		return
	}

	// 检查社交功能开关（Android 且 socialOn=false 时禁止访问与技师的聊天，但允许与客服沟通）
	const isAndroid = Capacitor.getPlatform() === 'android'
	if (isAndroid && !isSocialEnabled()) {
		const chatType = to.query.chatType
		const isCustomerServiceChat = chatType === '3' || chatType === 3 // 客服会话类型
		const socialRoutes = ['/chat', '/chat-message']
		if (socialRoutes.includes(to.path) && !isCustomerServiceChat) {
			console.log('🔒 社交功能已关闭，禁止访问技师聊天页面:', to.path)
			next(false) // 中断导航
			return
		}
	}

	// iOS 设备访问聊天页面时，直接打开原生聊天
	const isIOS = Capacitor.getPlatform() === 'ios'
	// isAndroid 已在上面声明 (line 754)
	const isNativeApp = Capacitor.isNativePlatform()

	if ((isIOS || isAndroid) && isNativeApp && to.path === '/chat-message' && to.query.chatId) {
		try {
			const userStore = useUserStore()
			const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'https://api-cust.test.kenzom.com'
			const token = localStorage.getItem('token') || ''

			let userId = userStore.userId
			if (!userId) {
				userId = userStore.userInfo?.userId || userStore.userInfo?.id || ''
			}
			if (!userId) {
				userId = localStorage.getItem('userId') || ''
			}
			const targetUserId = to.query.targetUserId || ''
			const freelancerId = to.query.freelancerId || ''

			console.log('🚪 从聊天列表进入，打开原生聊天 - chatId:', to.query.chatId, '平台:', isIOS ? 'iOS' : 'Android')
			console.log('🚪 参数 - targetUserId:', targetUserId, 'freelancerId:', freelancerId)

			// Android 使用 technicianType 区分客户（2-客户）
			const technicianType = '2'

			ChatPlugin.openChat({
				chatId: to.query.chatId,
				chatName: to.query.chatName || '聊天',
				chatIcon: to.query.chatIcon || '',
				targetUserId: String(targetUserId),
				freelancerId: String(freelancerId),
				chatType: String(to.query.chatType || ''),
				apiBaseUrl: apiBaseUrl,
				token: token,
				userId: String(userId),
				technicianType
			})

			// 中断导航，不进入 H5 页面
			next(false)
			return
		} catch (error) {
			console.log('打开原生聊天失败，显示 H5 页面:', error)
		}
	}

	// 1. 跳转到登录页时，记录目标页（redirect参数）
	if (to.path === '/login' && from.path && from.path !== '/login') {
		// 特殊处理：从设置页退出登录时，重定向到"我的"页面而非设置页
		let redirectPath = from.path;
		if (from.path === '/my/setting') {
			redirectPath = '/my';
		}
		const queryString = Object.keys(from.query).length > 0
			? `?${new URLSearchParams(from.query).toString()}`
			: '';
		to.query.redirect = encodeURIComponent(redirectPath + queryString);
		// 存储目标页到全局变量
		loginTargetPath = redirectPath;
	}

	// 2. 登录成功后跳转到目标页时，标记该页面“来自登录”
	if (to.path === '/login-callback') {
		localStorage.setItem('fromLogin', true);// 标记：当前页面是登录后跳转而来
		// 清除记录，避免重复标记
		loginTargetPath = '';
	}

	next()
})

// 路由错误处理
router.onError((error) => {
	console.error('🚨 路由错误:', error)
	console.error('🚨 错误堆栈:', error.stack)
	console.error('🚨 当前位置:', window.location.href)
	console.error('🚨 当前模式:', import.meta.env.MODE, import.meta.env.DEV ? '开发' : '生产')

	// 显示用户友好的错误提示
	if (error.message.includes('Failed to fetch')) {
		console.error('🚨 动态导入失败 - 可能的原因:')
		console.error('  1. 构建输出未正确部署')
		console.error('  2. 服务器配置问题')
		console.error('  3. 网络连接问题')
		console.error('  4. 访问的是开发服务器而非生产构建')
	}
})

// 路由成功后
router.afterEach((to, from) => {
	console.log('✅ 路由导航成功:', from.path, '->', to.path)
})

export default router